// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Loading_spinner__SNkdp","spin":"Loading_spin__bjODp"};